<div
  class="express-wash-packages-preview"
  [class.device-desktop]="deviceType === 'desktop'"
  [class.device-tablet]="deviceType === 'tablet'"
  [class.device-mobile]="deviceType === 'mobile'"
>
  <div class="modern-subpage-hero">
    <!-- Page Title Section (contains header inside) -->
    <section
      class="page-title-section website-element packages-title-element"
      *ngIf="isSectionVisible('hero_section') || isSectionVisible('page-title')"
      [class.selected]="getPackageSectionElement()?.selected"
      (click)="onPackageSectionClick($event)"
    >
      <!-- Header Section inside Page Title Section -->
      <div class="page-title-header-wrapper" (click)="onHeaderClick()">
        <div
          class="website-element header-element"
          *ngIf="isSectionVisible('header')"
          [class.selected]="getHeaderElement()?.selected"
        >
          <app-modern-page-header
            [logo]="getHeaderLogo()"
            [navigation]="getHeaderNavigation()"
            [ctaButton]="getHeaderCTAButton()"
            [visible]="true"
            [clickable]="true"
            [selected]="getHeaderElement()?.selected || false"
            [headingColor]="headingColor"
            [headingFont]="headingFont"
            [backgroundColor]="getHeaderBackgroundColor()"
            (navigationClick)="onNavigationClick($event)"
          >
          </app-modern-page-header>
        </div>
      </div>

      <!-- Page Title Content -->
      <div class="title-content-wrapper">
        <div class="title-container">
          <h1
            class="page-title"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()"
            [ngStyle]="getTitleStyles()"
          >
            {{ getPageTitle() }}
          </h1>
          <p
            class="page-subtitle"
            [style.color]="getParagraphColor()"
            [style.font-family]="getBodyFont()"
          >
            {{ getPageSubtitle() }}
          </p>
        </div>
      </div>
    </section>

    <!-- Loading State — package card shimmer -->
    <section
      *ngIf="loading"
      class="packages-section packages-shimmer-section"
      aria-busy="true"
      aria-label="Loading packages"
    >
      <div class="modern-package-cards-shimmer">
        <div class="modern-package-cards-shimmer__container">
          <div class="modern-package-cards-shimmer__grid">
            <div class="modern-package-cards-shimmer__card" *ngFor="let _ of shimmerSlots">
              <div class="modern-package-cards-shimmer__image"></div>
              <div class="modern-package-cards-shimmer__body">
                <div
                  class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--title"
                ></div>
                <div class="modern-package-cards-shimmer__badges">
                  <div
                    class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--badge"
                  ></div>
                  <div
                    class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--badge"
                  ></div>
                </div>
                <div class="modern-package-cards-shimmer__price-row">
                  <div class="modern-package-cards-shimmer__price-col">
                    <div
                      class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--label"
                    ></div>
                    <div
                      class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--price"
                    ></div>
                  </div>
                  <div class="modern-package-cards-shimmer__price-col">
                    <div
                      class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--label"
                    ></div>
                    <div
                      class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--price"
                    ></div>
                  </div>
                </div>
                <div
                  class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--main-price"
                ></div>
                <div
                  class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--feature"
                ></div>
                <div
                  class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--feature"
                ></div>
                <div
                  class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--feature modern-package-cards-shimmer__line--feature-short"
                ></div>
                <div
                  class="modern-package-cards-shimmer__line modern-package-cards-shimmer__line--button"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <p>{{ error }}</p>
    </div>

    <!-- Packages Grid Section -->
    <section
      class="packages-section website-element"
      *ngIf="isSectionVisible('package_section') && !loading && !error && packages.length > 0"
      [class.selected]="getPackageSectionElement()?.selected"
      (click)="onPackageSectionClick($event)"
    >
      <div class="packages-container">
        <div class="packages-grid">
          <div class="package-card" *ngFor="let package of packages; trackBy: trackById">
            <!-- Package Image -->
            <div class="package-image">
              <img
                [src]="getPackageImage(package)"
                [alt]="package.package_name"
                class="package-icon"
                [style.object-fit]="getPackageImageFit(package)"
                (error)="onImageError($event)"
              />
            </div>

            <!-- Package Content -->
            <div class="package-content">
              <!-- Package Name -->
              <h3
                class="package-name"
                [style.color]="getHeadingColor()"
                [style.font-family]="getHeadingFont()"
              >
                {{ package.package_name }}
              </h3>

              <!-- Package Badges -->
              <div class="package-badges">
                <span
                  class="badge badge-single"
                  *ngIf="hasSingleWash(package)"
                  [class.active]="getSelectedPlanType(package) === 'single'"
                  (click)="selectPlanType(package.id, 'single', $event)"
                  >Single</span
                >
                <span
                  class="badge badge-monthly"
                  *ngIf="hasMonthlyMembership(package)"
                  [class.active]="getSelectedPlanType(package) === 'monthly'"
                  (click)="selectPlanType(package.id, 'monthly', $event)"
                  >Monthly Membership</span
                >
                <span
                  class="badge badge-unlimited"
                  *ngIf="isUnlimited(package) && !hasMonthlyMembership(package)"
                  >Unlimited</span
                >
              </div>

              <!-- Price Grid (2 columns) -->
              <div class="price-grid">
                <div
                  class="price-column"
                  *ngIf="formatPrice(getStrikeoffPrice(package)) !== '$0.00'"
                >
                  <div class="price-label">Total Price</div>
                  <div class="price-strikethrough">
                    {{ formatPrice(getStrikeoffPrice(package)) }}
                  </div>
                </div>
              </div>

              <!-- Main Price -->
              <div class="main-price" [style.color]="getHeadingColor()">
                {{ formatPrice(getListPrice(package)) }}
              </div>

              <!-- License Note -->
              <p class="license-note" *ngIf="package.license_plate_needed">
                *License plate required for this wash.
              </p>

              <!-- Features Section -->
              <div class="features-section">
                <h4
                  class="section-heading"
                  [style.color]="getHeadingColor()"
                  [style.font-family]="getHeadingFont()"
                >
                  What this includes
                </h4>
                <ul class="features-list">
                  <li
                    class="feature-item"
                    *ngFor="let feature of package.features; trackBy: trackByIndex"
                  >
                    <span class="feature-icon">✓</span>
                    <span class="feature-text">{{ feature }}</span>
                  </li>
                </ul>
              </div>

              <!-- Locations Section -->
              <div
                class="locations-section"
                *ngIf="package.locations && package.locations.length > 0"
              >
                <h4 class="section-heading" [style.color]="getHeadingColor()">
                  Available in locations
                </h4>
                <div class="locations-list">
                  <span
                    class="location-item"
                    *ngFor="
                      let location of package.locations;
                      let isLast = last;
                      trackBy: trackByIndex
                    "
                  >
                    • {{ location.name }}<span *ngIf="!isLast"> </span>
                  </span>
                </div>
              </div>

              <!-- Buy Button -->
              <button
                class="buy-button"
                [style.background-color]="getPrimaryColor()"
                [style.color]="getHeadingColor()"
                (click)="onBuyNowClick(package, $event)"
              >
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- No Packages State -->
    <div *ngIf="!loading && !error && packages.length === 0" class="no-packages-state">
      <p>No packages available at the moment.</p>
    </div>
  </div>

  <!-- Footer -->
  <div
    class="website-element footer-element"
    *ngIf="isSectionVisible('footer')"
    [class.selected]="getFooterElement()?.selected"
    (click)="onFooterClick($event)"
  >
    <app-modern-page-footer
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [backgroundColor]="getFooterBackgroundColor()"
    >
    </app-modern-page-footer>
  </div>

  <!-- Package Selection Modal -->
  <app-shared-package-selection-modal
    [isVisible]="showPackageSelectionModal"
    [packages]="getPackagesForModal()"
    (close)="onClosePackageModal()"
    (packageSelected)="onPackageSelected($event)"
  >
  </app-shared-package-selection-modal>
</div>
